import { IRailway } from '../../types/geo';
import { DEFAULT_STATION_DISTANCE, SavedFiltersIds } from '../../interfaces/filters';
import { IThunkActionCreator } from '../../types/store';
import { isArrayWithItems } from '../../utils';
import { setStationFilter } from '../filters/actions';
import { removeSavedFilter } from '../saved_filters/removeSavedFilter';
import { onChangeStationDistance } from './actions';

export function selectStations(
  stations: IRailway[],
  save: boolean = true,
  distance: number = DEFAULT_STATION_DISTANCE,
): IThunkActionCreator {
  return (dispatch, getState) => {
    const {
      savedFilters: { items },
    } = getState();

    const stationsSavedFilter = items.find(({ id }) => id === SavedFiltersIds.StationDistance);
    if (stationsSavedFilter) {
      dispatch(removeSavedFilter(stationsSavedFilter));
    }
    if (isArrayWithItems(stations)) {
      dispatch(setStationFilter(stations.map(({ id }) => id)));
      dispatch(onChangeStationDistance(distance, save));
    }
  };
}
